import React, { memo } from 'react'
import PropTypes from 'prop-types'

const Marker = ({ onClick, onMouseOver, onMouseOut, resultId, location, hover, image, dpr, top, left, newMarkers }) => {
  const className = `map-marker${hover ? ' result-hover' : ''}`
  const transform = `translate(${Math.round(left * 1000) / 1000}px, ${Math.round(top * 1000) / 1000}px)`

  const handleClick = () => {
    onClick && onClick(resultId)
  }

  const handleMouseOver = () => {
    onMouseOver && onMouseOver(location)
  }

  const handleMouseOut = () => {
    onMouseOut && onMouseOut(location)
  }

  const imageFunc = () => {
    const finalDpr = typeof window !== 'undefined' ? window.devicePixelRatio || dpr : dpr
    const dprExtension = finalDpr >= 2 ? '@2x' : ''

    return `/images/map/pin-${image || 'green'}-large${hover ? '-hover' : ''}${dprExtension}.png`
  }

  if (newMarkers) {
    return (
      <img
        className={className}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onClick={handleClick}
        alt={image === 'orange' ? 'yellow drop pin icon' : 'green drop pin icon'}
        src={`/images/map/${image || 'green'}-drop-pin${hover ? '-shadow' : ''}-icon.png`}
        width={37}
        height={42}
        style={{ zIndex: hover ? 10 : 5, transform, position: 'absolute' }}
      />
    )
  }

  return (
    <div
      className={className}
      style={{ zIndex: hover ? 10 : 5, backgroundImage: `url(${imageFunc()})`, transform, position: 'absolute' }}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    />
  )
}

Marker.propTypes = {
  onClick: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  resultId: PropTypes.number,
  location: PropTypes.object.isRequired,
  hover: PropTypes.bool.isRequired,
  image: PropTypes.string,
  dpr: PropTypes.number,
  top: PropTypes.number,
  left: PropTypes.number,
  newMarkers: PropTypes.bool
}

export default memo(Marker)
